<template>
  <div>
    <form
      id="subscribe-form"
      action="https://srax.us1.list-manage.com/subscribe/post-json?u=b0dec55260536a21ace4f46e7&amp;id=da220d7f16&amp;f_id=004234e1f0"
      method="get">
      <div class="form__fields">
        <h1>Book your Demo</h1>
        <hr>
        <div class="form__split">
          <div class="form__split--item">
            <p>Full Name <b>*</b></p>
            <input type="text" value="" name="FNAME" />
          </div>
          <div class="form__split--item">
            <p>Email <b>*</b></p>
            <input type="email" value="" name="EMAIL" />
          </div>
        </div>
        <div class="form__split">
            <div class="form__split--item">
                <p>Company <b>*</b></p>
                <input type="text" value="" name="CMPANY" />
            </div>
            <div class="form__split--item">
                <p>Phone Number <b>*</b></p>
                <input type="text" value="" name="PHONE" />
            </div>
        </div>
        <p class="--midtext">
          Choose a suitable day and time, and wait for an invitation email
        </p>
        <div class="form__split">
            <div class="form__split--item">
                <p>Available Date <b>*</b></p>
                <select name="MMERGE6" class="required" id="mce-MMERGE6">
                  <option value=""></option>
                  <option value="Monday">Monday</option>
                  <option value="Tuesday">Tuesday</option>
                  <option value="Wednesday">Wednesday</option>
                  <option value="Thursday">Thursday</option>
                  <option value="Friday">Friday</option>
                </select>
            </div>
            <div class="form__split--item">
                <p>Time Slot <b>*</b></p>
                <select name="MMERGE5" class="required" id="mce-MMERGE5">
                  <option value=""></option>
                  <option value="9:00 am - 9:30 am ET">9:00 am - 9:30 am ET</option>
                  <option value="9:30 am - 10:00 am ET">9:30 am - 10:00 am ET</option>
                  <option value="10:00 am - 10:30 am ET">10:00 am - 10:30 am ET</option>
                  <option value="10:30 am - 11:00 am ET">10:30 am - 11:00 am ET</option>
                  <option value="11:00 am - 11:30 am ET">11:00 am - 11:30 am ET</option>
                  <option value="11:30 am - 12:00 pm ET">11:30 am - 12:00 pm ET</option>
                </select>
            </div>
        </div>

        <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
        <div style="position: absolute; left: -5000px;" aria-hidden="true">
            <input type="text" name="b_b0dec55260536a21ace4f46e7_da220d7f16" tabindex="-1" value="">
        </div>

      </div>
      <div class="form__submit">
        <input type="submit" value="Submit" name="subscribe" />
      </div>
    </form>
    <div id="subscribe-result"></div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/styles/components/form.scss";
</style>

<script>
import $ from "jquery";

export default {
  name: "Form",
  mounted() {
    $(document).ready(function() {
      ajaxMailChimpForm($("#subscribe-form"), $("#subscribe-result"));

      // Turn the given MailChimp form into an ajax version of it.
      // If resultElement is given, the subscribe result is set as html to
      // that element.
      function ajaxMailChimpForm($form, $resultElement) {
        // Hijack the submission. We'll submit the form manually.
        $form.submit(function(e) {
          e.preventDefault();

          if (!isValidEmail($form)) {
            var error = "A valid email address must be provided.";
            $resultElement.html("<div class='text'>" + error + "</div>");
            $resultElement.css("color", "red");
          } else {
            $resultElement.css("color", "#232323");
            $resultElement.html("<div class='text'>Sending...</div>");
            submitSubscribeForm($form, $resultElement);
          }
        });
      }

      // Validate the email address in the form
      function isValidEmail($form) {
        // If email is empty, show error message.
        // contains just one @
        var email = $form.find("input[type='email']").val();
        if (!email || !email.length) {
          return false;
        } else if (email.indexOf("@") == -1) {
          return false;
        }

        return true;
      }

      // Submit the form with an ajax/jsonp request.
      // Based on http://stackoverflow.com/a/15120409/215821
      function submitSubscribeForm($form, $resultElement) {
        $.ajax({
          type: "GET",
          url: $form.attr("action"),
          data: $form.serialize(),
          cache: false,
          dataType: "jsonp",
          jsonp: "c", // trigger MailChimp to return a JSONP response
          contentType: "application/json; charset=utf-8",

          /* eslint-disable */

          error: function(error) {
            // According to jquery docs, this is never called for cross-domain JSONP requests
          },

          success: function(data) {
            if (data.result != "success") {
              var message =
                data.msg ||
                "<div class='text'> Sorry. Unable to subscribe. Please try again later.</div>";
              $resultElement.css("color", "red");

              if (data.msg && data.msg.indexOf("already subscribed") >= 0) {
                message =
                  "<div class='text'>You've already submitted your information. Thank you.</div>";
                $resultElement.css("color", "#232323");
              }

              $resultElement.html(message);
            } else {
              $resultElement.css("color", "#232323");
              $resultElement.html(
                "<div class='text'><h1>Thank you!</h1> <p>We will be in contact soon.</p></div>"
              );
              $form.css({
                display: "none",
              });
            }
          },
        });
      }
    });
  },
};
</script>
